import {
  Button,
  Flex,
  Label,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  RadioButton,
  Text,
} from '@modusign/design-system';
import { useState } from 'react';

import { AddressBookContact } from '@app/features/addressBook';
import { DefaultForwardingMethod } from '@app/features/addressBook/types';

export interface DefaultForwardingMethodSelectModalProps {
  contact: AddressBookContact;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (selectedForwardingMethod: DefaultForwardingMethod) => void;
}
export default function DefaultForwardingMethodSelectModal({
  contact,
  isOpen,
  onClose,
  onSelect,
}: DefaultForwardingMethodSelectModalProps) {
  const [defaultForwardingMethod, setDefaultForwardingMethod] = useState<DefaultForwardingMethod>(
    contact.defaultForwardingMethod || 'EMAIL'
  );
  return (
    <Modal isOpen={isOpen} maxWidth="xs" onClose={onClose}>
      <ModalTitle>전송 수단 선택</ModalTitle>
      <ModalContent>
        <Text as="p" mb={7} textAlign="center">
          {`'${contact.name}'`}님에게 어떻게 알림을 보낼까요?
        </Text>
        <Flex
          alignItems="center"
          backgroundColor="boxBackgroundNeutralBase"
          border="1px solid"
          borderColor="boxBorderNeutralBase"
          gap={9}
          justifyContent="center"
          px={7}
          py={6}
        >
          <RadioButtonWithLabel
            checked={defaultForwardingMethod === 'EMAIL'}
            id="default-forwarding-method-email"
            labelText="이메일로 전송"
            onClick={() => setDefaultForwardingMethod('EMAIL')}
          />
          <RadioButtonWithLabel
            checked={defaultForwardingMethod === 'KAKAO'}
            id="default-forwarding-method-kakao"
            labelText="카카오톡으로 전송"
            onClick={() => setDefaultForwardingMethod('KAKAO')}
          />
        </Flex>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onClose}>취소</Button>
        <Button ml={2} variant="primary" onClick={() => onSelect(defaultForwardingMethod)}>
          확인
        </Button>
      </ModalFooter>
    </Modal>
  );
}

function RadioButtonWithLabel({
  checked,
  id,
  labelText,
  onClick,
}: {
  checked: boolean;
  id: string;
  labelText: string;
  onClick: () => void;
}) {
  return (
    <Flex alignItems="center">
      <RadioButton checked={checked} id={id} onClick={onClick} />
      <Label
        htmlFor={id}
        mb={0}
        ml={2}
        sx={{
          cursor: 'pointer',
          fontWeight: 'medium',
        }}
      >
        {labelText}
      </Label>
    </Flex>
  );
}
